import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableAdminOrganizations from './tableAdminOrganizations';

export default {
  title: 'Organizations',
  attributeName: 'organizations',
  helpText: 'Organizations',
  fields: [
    {
      attributeName: 'organizations',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableAdminOrganizations,
    },
  ],
};
